import { useState } from 'react';
import { useDebounce } from 'react-use';
import { FixMe } from '@greenkub-fronts/shared/interface';

export const useCustomDebounce = (
  callbackFn: () => void,
  delay: number,
  value: FixMe[]
) => {
  const [isInitialRender, setIsInitialRender] = useState<boolean>(true);

  useDebounce(
    () => {
      if (isInitialRender) {
        setIsInitialRender(false);
      } else {
        callbackFn();
      }
    },
    delay,
    value
  );
};

export default useCustomDebounce;
